module.exports = __webpack_public_path__ + "img/Reunion.90d4e070.svg";